import { Card, Grid } from "@mui/material";
import Accessory, { IAccessory } from "../Components/Cards/Accessory";
import AccessoriesDB from "../Assets/AccessoriesDB.json";
import { HeaderCard } from "../Components/Cards/MainCard";
import { useEffect } from "react";

const AccessoriesPage: React.FC = () => {
    const accessories = AccessoriesDB as object[];
    
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    
    return (
        <>
            <HeaderCard />
            {
                accessories.map((accFolder) => {
                    return (
                        Object.values(accFolder).map((category, index) => {
                            
                            category = category as IAccessory[];
                            return (
                                <div key={index}>
                                    <Grid
                                        container
                                        spacing={{ xs: 2, md: 3 }}
                                        columns={{ xs: 4, sm: 9, md: 12, lg: 8 }}
                                        paddingBottom={2}
                                    >
                                        {
                                            Object.values(category).map((item) => {
                                                const accessory = item as IAccessory;
                                                return (
                                                    <Grid key={accessory.id} item xs={2} sm={3} md={3} lg={2} >
                                                        <Card sx={{ maxWidth: 480, display: "flex", height: "100%" }} elevation={12}>
                                                            <Accessory {...accessory}></Accessory>
                                                        </Card>
                                                    </Grid>
                                                )
                                            })}
                                    </Grid>
                                    {index !== Object.keys(accFolder).length -1
                                    ? <HeaderCard text="" /> : null }
                                    
                                </div>

                            )
                        })
                    )
                })
            }
        </>
    );
};

export default AccessoriesPage;